import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import face1 from "../assets/img/face1.png";
import sbh from "../assets/img/sbh.png";
import techtrix from "../assets/img/techtrix.png";
import rcrcc from "../assets/img/rcrcc.png"
import qr from "../assets/img/qr.png"
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';


export const Projects = () => {

  const projects = [
    {
      title: "Realtime Hospital Management System with face recognition ",
      description: <a href="https://github.com/Sansrita/SBH-PROJECT">
      <button>Click me</button>
    </a>,
      imgUrl: face1,
    },
    {
      title: "Rotaract Club Of RCCIIT",
      description: <a href="https://www.rcrcciit.in/">
      <button>Click me</button>
    </a>,
      imgUrl: rcrcc,
    },
    {
      title: "TechTrix 2023",
      description: <a href="https://techtrix.rcciit.org.in/">
      <button>Click me</button>
    </a>,
      imgUrl: techtrix,
    },
    {
      title: " Smart Bengal Hackathon Official Website",
      description: <a href="https://www.sbh.rcciit.org.in/ ">
      <button>Click me</button>
    </a>,
      imgUrl: sbh,
    },
    {
      title: " Python-QrCode-Generator",
      description: <a href="https://github.com/Sansrita/Python-QrCode-Generator">
      <button>Click me</button>
    </a>,
      imgUrl: qr,
      
    },
  ];
  
  

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p></p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    
                  </Tab.Content>
                </Tab.Container>
              </div>
              }
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}